'use client';

import { createSlice } from '@reduxjs/toolkit';
import { currentUserStateType } from '../types';

const initialState = {
} as currentUserStateType;


export const currentUserSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    changeState: (state, action) => {
      return {
        ...state, ...action.payload
      }
    }
  },
});

export const { changeState } = currentUserSlice.actions;
export default currentUserSlice.reducer;